import BaseStyle from 'primevue/base/style';

export default BaseStyle.extend({
    name: 'common'
});
